module.exports = __webpack_public_path__ + "static/img/kuaikebi_bg.7ac0b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kuaikebi_bg.png
// module id = tnhF
// module chunks = 0